module.exports = __webpack_public_path__ + "img/renwu.8f691770.png";